<template>
  <div
    class="body-container msg-detail"
    v-if="detail.id"
    :class="{ while: type == 1 }"
  >
    <div class="activeDetail">
      <div class="top-box">
        <div class="title">{{ detail.title }}</div>
        <div class="info-box">{{ detail.sendTime | timeSub(16) }}</div>
      </div>
      <div class="jump-product" v-if="detail.productList&&detail.productList.length">
        <div class="name">产品名称：</div>
        <div
          v-for="item in detail.productList"
          :key="item.productCode"
          @click="jumpPage(item.url)"
          class="name-link"
        >
          {{ item.productName }}
        </div>
        <div class="name time">上架时间：{{ detail.releaseTime }}</div>
      </div>
      <div v-html="detail.content" class="content" v-if="type == 1 && detail.content"></div>
      <div class="content" v-if="detail.linkUrl">跳转链接：
        <a :href="detail.linkUrl">{{ detail.linkUrl }}</a>
      </div>
      <div class="box" v-else>
        <div v-for="(item, i) in data" :key="i">
          <div class="row" v-if="item.type != 1">
            <div class="key" v-if="item.text">{{ item.key }}：</div>
            <div class="key big" v-else>{{ item.key }}</div>
            <div class="text" v-if="item.text">{{ item.text }}</div>
          </div>
          <div class="statusBox" v-else>
            <div class="item-box">
              <span class="title1">{{ item.key }}:</span>
              <img id="copy4" data-clipboard-action="copy"
              :data-clipboard-text="item.text" @click="copy('#copy4')" src="@static/images/fuzhi.png" class="btn1" />
            </div>
            <div class="items">{{ item.text }}</div>
          </div>
        </div>
        <div v-if="data.receiptDesc" class="statusBox">
          <div class="item-box">
            <span class="title1">回执操作指引:</span>
          </div>
            <div class="items"><span v-for="(v, index) in data.receiptDesc.split('<br>')" :key="index">{{ v }}<br /></span></div>
        </div>
        <div v-if="data.revisitDesc" class="statusBox">
          <div class="item-box">
            <span class="title1">回访操作指引:</span>
          </div>
            <div class="items"><span v-for="(v, index) in data.revisitDesc.split('<br>')" :key="index">{{ v }}<br /></span></div>
        </div>
        <div class="row info" v-if="info.key">
          <div class="key">{{ info.key }}：</div>
          <div class="text">{{ info.text }}</div>
          <span
            class="copy-btn"
            @click="copy('#copy1')"
            v-if="detail.orderStatus == 1"
            id="copy1"
            data-clipboard-action="copy"
            :data-clipboard-text="detail.payUrl"
            >复制</span
          >
        </div>
      </div>
      <!-- <span class='share-btn' @click="goProductDeatil(detail.productCode)" v-if="detail.hasProduct">查看产品</span> -->
      <span
        class="share-btn"
        @click="jumpPage(detail.manualUrl)"
        v-if="detail.orderStatus == 1 && detail.checkInsuranceStatus == 2"
        >人核进度</span
      >
      <span
        class="share-btn"
        @click="copy('#copy2')"
        v-if="detail.orderStatus == 1 && detail.checkInsuranceStatus == 1"
        id="copy2"
        data-clipboard-action="copy"
        :data-clipboard-text="detail.payUrl"
        >复制支付链接</span
      >
    </div>
  </div>
</template>

<script>
import { common } from "@/api/mixins";
import Clipboard from 'clipboard';
export default {
  mixins: [common],
  data() {
    return {
      id: "",
      type: "", //1普通消息 2订单消息 3日程
      data: [],
      info: {
        key: "",
        text: "",
      },
      detail: {
        title: "",
        createTime: "",
        content: "",
      },
    };
  },
  created() {
    this.id = this.$route.query.id;
    this.type = this.$route.query.type;
    this.getDetail();
    this.$weixin.hideMenu();
  },
  methods: {
    // 复制上传资料链接
    copy(id) {
      var clipboard = new Clipboard(id);
      clipboard.on("success", (e) => {
        console.log(e);
        this.$notice.msg("复制成功");
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        //console.log('该浏览器不支持自动复制')
        // 释放内存
        clipboard.destroy();
      });
    },
    getDetail: function () {
      let url
      if(this.type == 1){
        url = "/api/msg/read/msg"
      }else if(this.type == 2){
        url = "/api/msg/read/serviceMsg"
      }else{
        url = "/app/calendarRemindLog/readMsg"
      }
      this.$http({
        url: url,
        type: "GET",
        data: {
          id: this.id,
        },
      }).then((resData) => {
        this.detail = resData.data;
        if (this.type == 2) {
          if(this.detail.url){
            const url = this.detail.url;
            if(url.indexOf(this.$config.root) == 0){
              this.$router.replace(url.replace(this.$config.root, ''));
            }else{
              location.replace(url);
            }
            return
          }
          const data = this.detail.content.split("\n");
          const outData = [];
          data.forEach((item) => {
            if (item == "") {
              return false;
            }
            console.log(item)
            const arr = item.split("：");
            if(!arr[1]){
              outData.push({
                key:item,
                text:"",
              });
              return false;
            }
            const bean = {
              key: arr[0],
              text: item.replace(arr[0] + "：", ""),
            };
            if (arr[0] == "原因" || arr[0] == "支付链接") {
              this.info = bean;
            } else {
              outData.push(bean);
            }
            outData.forEach((item1,index1)=>{
              if(item1.key.includes('链接') ){
                outData[index1].type=1                
              }
              if(item1.key == '回执操作指引'){
                outData.receiptDesc = item1.text
                outData.splice(index1,1)
              }
              if(item1.key == '回访操作指引'){
                outData.revisitDesc = item1.text
                outData.splice(index1,1)
              }
            })
          });
          this.data = outData;
        }else if(this.type == 3){
          location.href = this.detail.url
        }
      });
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.msg-detail {
  background: #f8f8f8;
  min-height: 100vh;
  padding-top: 30px;
  &.while {
    background: #fff;
    padding-bottom: 40px;
    padding-top: 0;
    .top-box {
      padding-left: 0;
      padding-right: 0;
      .title {
        white-space: normal;
      }
    }
  }
}
video {
  width: 100%;
  max-height: 40vh;
}
.share-btn {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 750px;
  text-align: center;
  line-height: 80px;
  background-color: #0092ff;
  color: #fff;
  font-size: 30px;
}
.activeDetail {
  margin: 0 30px 30px;
  border-radius: 16px;
  background: #fff;
  .jump-product {
    margin-top: 20px;
    .name {
      display: flex;
      color: #333;
      font-size: 30px;
    }
    .name-link{
      color: #236dff;
      margin-top:20px;
      font-size: 30px;
    }
    .time {
      margin-top: 20px;
    }
  }
  .top-box {
    padding: 20px 30px;
    border-bottom: 1px solid #ddd;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
  }
  .title {
    position: relative;
    font-size: r(36);
    color: #333;
    font-weight: 700;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .info-box {
    font-size: r(24);
    color: #888;
  }
  .box {
    padding: 25px 30px;
    line-height: 2;
    .row {
      .key {
        display: inline-block;
        width: 220px;
        font-size: 28px;
        color: #999;
        &.big {
          width: 100%;
        }
      }
      .text {
        display: inline-block;
        font-size: 28px;
        color: #666;
        width: calc(100% - 230px);
        vertical-align: top;
        word-break: break-all;
      }
      &.info {
        background: #f9f9f9;
        border-radius: 8px;
        padding: 20px 30px;
        margin-top: 15px;
        position: relative;
        .key {
          color: #333;
          font-size: 28px;
          font-weight: 700;
          display: block;
        }
        .text {
          font-size: 24px;
          width: 100%;
        }
        .copy-btn {
          display: block;
          width: 80px;
          text-align: center;
          line-height: 36px;
          background: #ffebce;
          border-radius: 10px;
          font-size: 24px;
          color: #ff7d00;
          position: absolute;
          right: 30px;
          top: 30px;
        }
      }
    }
  }
  .content {
    font-size: medium;
    padding: r(30) 0;
    line-height: 2;
    color: #666;
    /deep/ video,
    /deep/ iframe,
    /deep/ img {
      max-width: 100% !important;
      display: block !important;
      margin: auto !important;
    }
    /deep/ a {
      display: block;
      word-break: break-all;
    }
  }
}
.statusBox {
  background: #f5f5f5;
  padding: 20px;
  margin-bottom: 20px;
  word-break: break-all;
  border-radius: 10px;
  .item-box {
    display: flex;
    justify-content: space-between;
  }

  .title1 {
    font-weight: 500;
    font-size: 28px;
    color: #333333;
    line-height: 38px;
  }

  .btn1 {
    width: 88px;
    height: 40px;
  }

  .items {
    font-weight: 400;
    font-size: 26px;
    color: #666666;
    line-height: 34px;
    margin-top: 15px;
  }
}
</style>
